import { Loading } from '@chiroup/components/Loading';

type Props = {
  title?: string;
};

export const LoadingPage = ({ title }: Props) => {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 px-4 py-8 text-center"
      data-component="global-loading"
      role="status"
      aria-live="polite"
    >
      <div aria-hidden="true">
        <Loading color="text-gray-400" size={10} />
      </div>
      <p className="text-sm font-medium text-gray-500 dark:text-dark-gray-100">
        {title || 'Loading…'}
      </p>
    </div>
  );
};
